import { BREAKPOINTS } from "../config/breakpoints";
import React, { useState, useEffect, useLayoutEffect } from "react";
import styled from "styled-components";
import SearchBar from "../Generic/SearchBar";
import { Table, Thead, Trow, Tcol, Tbody } from "../Generic/Table";
import moment from "moment";
import { getApi } from "../config/api";
import {
	errorNotification,
	successNotification,
} from "../Generic/Notifications";
import Button from "../Generic/Button";
import {
	forceDownloadCSV,
	search,
	setProperty,
} from "../util/util";
import InventoryService from "./Services/InventoryService";
import * as OperationActions from "./Actions/index";
import { INVENTORY_ERROR_MESSAGES } from "./Constants";
import Loader from "../Generic/Loader";
import useQuery from "../util/hooks/useQuery";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { formatDisplayDate } from "../util/date.util";
import { zIndex } from "../config/zIndex";

const Page = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow-x:hidden;
	align-items: center;
	padding: 0 2rem 2rem 2rem;
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		padding: 0 0 2rem 0;
	}
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		padding: 0 1rem 1rem 1rem;
	}
`;

const TabHead = styled.div`
	margin: ${(props) => props.margin};
	height: ${(props) => props.height};
	width: ${(props) => props.width};
	padding: ${(props) => props.padding};
	color: ${(props) => props.color};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	background: ${(props) => props.background};
	border-radius: ${(props) => props.borderRadius};
`;

TabHead.defaultProps = {
	padding: "0.7rem 2rem",
	background: "#fff",
	fontSize: "1.2rem",
	fontWeight: "600",
	borderRadius: "10px",
	margin: "1rem 1rem 0 0",
};

const Container = styled.div`
	display: flex;
	flex-direction: row;
	max-width: max-content;
	padding: ${(props) => props.padding};
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
`;

const Div = styled.div`
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	position: ${(props) => props.position};
	width: ${(props) => props.width};
	display: flex;
	flex-direction: ${(props) => props.flexDirection};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	font-family: ${(props) => props.fontFamily};
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		justify-content: ${(props) => props.jContentBefore1000};
	}
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: ${zIndex.modalBackdrop};
`;

const ConfirmModal = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	width: 22rem;
	border-radius: 10px;
	overflow-x: hidden;
	z-index: ${zIndex.modal};
`;

const TabContain = styled.div`
	background: #fff;
	display: flex;
	width: max-content;
	align-items: center;
	padding: 0 0;
	margin: 1rem 0 1.5rem 0;
	border-radius: 10px;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		width: 100%;
		overflow-x: auto;
		padding-bottom: 0.5rem;
	}
`;

const Tab = styled.div`
	margin: 0;
	padding: 1rem;
	width: max-content;
	display: flex;
	z-index: ${zIndex.tab};
	background: transparent;
	transition: 0.3s all linear;
	flex-shrink: 0;
`;

const Slider = styled.div`
	position: absolute;
	background: darkgrey;
	border-radius: 10px;
	transition: 0.2s all linear;
`;

const ErrorMessage = styled.div`
	height:max-content;
	width:max-content;
	position:absolute;
	top:-8px;
	z-index: ${zIndex.errorTooltip};
	background:#FFF;
	box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`;

const TABS = {
	INGREDIENTS: 1,
	BASE_ITEMS: 2,
};

const SEARCH_PARAMS = {
	[TABS.INGREDIENTS] : ["itemName", "module", "system"],
	[TABS.BASE_ITEMS] : ["itemName"]
}

const ErroredBackground = "rgba(244, 66, 54, 0.2)";

const Inventory = (props) => {
	const pageQuery = useQuery();
	const { kitchenId, inventoryData } = props;
	const [tab, showTab] = useState(TABS.INGREDIENTS);
	const [searchParam, setSearchParam] = useState(SEARCH_PARAMS[TABS.INGREDIENTS]);
	const [query, setQuery] = useState("");
	const [loading, setLoading] = useState(true);
	const [confirmModal, showConfirmModal] = useState(false);
	const [invFileModal, showInvFileModal] = useState(false);

	function findAndScroll(query = pageQuery) {
		const module = pageQuery.get('module');
		const system = pageQuery.get('system');
		if(module && system) {
			const elementId = `${module}-${system}`;
			scrollToRequiredItem(elementId);
			highlightElement(elementId);
		}
	}

	function scrollToRequiredItem(id) {
		const element = document.getElementById(id);
		if(!element) return;
		element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
	}

	function highlightElement(id) {
		const animatedClass = "highlight-element"
		const element = document.getElementById(id);
		if(!element) return;
		element.classList.add(animatedClass)
		//element.addEventListener("animationend", () => { element.classList.remove(animatedClass) });
	}

	function checkItemAvailable(item) {
		const { isOnline, isDocked, isLocked, availableAmount, itemExpiresAt } = item;
		const expiryTime = item && new Date(itemExpiresAt);
		const current = new Date();

		if (!isOnline) {
			if(!isDocked) return { disabled: true, disabledMessage: INVENTORY_ERROR_MESSAGES.OFFLINE } 
			else return { error: INVENTORY_ERROR_MESSAGES.OFFLINE }
		}

		if (!isDocked) {
			return { disabled: true, disabledMessage: INVENTORY_ERROR_MESSAGES.NOT_DOCKED };
		}

		if (isLocked) {
			return { error: INVENTORY_ERROR_MESSAGES.LOCKED };
		}

		if (current >= expiryTime) {
			return { error: INVENTORY_ERROR_MESSAGES.EXPIRED };
		}

		if (isDocked && availableAmount === 0) {
			return { error: INVENTORY_ERROR_MESSAGES.SOLD_OUT };
		}

		return { available: true };
	}

	function ingredientsSorter(a, b) {
		return a.key.localeCompare(b.key, undefined, { numeric: true });
	}

	function removeAlphabets(string) {
		return string.replace(/\D/g,'');
	}

	function mapInventory(inventory) {
		const { inventoryData, availableItems } = inventory;
		const { modules } = inventoryData;
		let baseItems = [],
			ingredients = [],
			others = {};

		//Segregating the base plates and the ingredients
		for (const module in modules) {
			const { systems } = modules[module];
			for (const system in systems) {
				const systemData = systems[system];
				const { itemId, isBaseItem, itemName, itemExpiresAt } = systemData;
				if (!itemId) {
					setProperty(others, systemData, `${module}.${system}`);
					continue;
				}
				const { totalAvailableAmount } = availableItems?.[itemId] || {};
				
				if (isBaseItem) {
					const alreadyAdded = baseItems.find((item) => item.itemId === itemId);
					if(alreadyAdded) {
						continue;
					}
					baseItems.push({
						itemId,
						itemName,
						itemExpiresAt,
						totalAvailableAmount: totalAvailableAmount || 0,
					});
				} else {
					const itemAvailability = checkItemAvailable(systemData);
					const compiledData = {
						key: `${removeAlphabets(module)}-${removeAlphabets(system)}`,
						module,
						system,
						...systemData,
						...itemAvailability,
					};
					ingredients.push(compiledData);
				}
			}
		}

		ingredients = ingredients.sort(ingredientsSorter);

		return { baseItems, ingredients, others };
	}

	// function showModal(slot, action) {
	// 	const Action = action === "dock" ? "undock" : "dock";
	// 	setSlot(slot);
	// 	setAction(Action);
	// 	showConfirmModal(true);
	// }

	function closeModal(event) {
		document.addEventListener("keydown", function (event) {
			if (event.key === "Escape") {
				showConfirmModal(false);
				showInvFileModal(false);
			}
		});
	}

	async function undockSystem(payload) {
		const response = InventoryService.undockSystem(kitchenId, payload);
		const { data, error } = await response;
		if (data) {
			successNotification(`Module ${payload.moduleId} System: ${payload.systemId} undocked`);
			await FetchInventoryData();
		}
		if (error) {
			errorNotification(`Failed to undock Module ${payload.moduleId} System: ${payload.systemId}`);
		}
	}

	async function getInventoryFile() {
		var fromISO = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
		var toISO = new Date(new Date()).toISOString();
		const response = await getApi(
			`/inventory/file?dateFrom=${fromISO}&dateTo=${toISO}`,
			{},
			props.kitchenId
		);
		const { data, error } = response;
		if (data) {
			forceDownloadCSV(data, "inventory-snapshot.csv");
		}
		if (error) {
			errorNotification("Could not get Inventory File");
		}
	}

	function sliderMovement() {
		//Select all the elements
		let slider = document.getElementById("slider");
		let active = document.querySelector(".activeTab");
		let elements = document.querySelectorAll(".tab");
		let contain = document.getElementById("contain");

		//Get the position of the active tab
		let activePosition = active && active.getBoundingClientRect();
		let containPosition = contain && contain.getBoundingClientRect();

		//Set the inital position of slider to the active tab
		if (slider && activePosition) {
			slider.style.left = containPosition.left - activePosition.left + "px";
			slider.style.width = activePosition.width + "px";
			slider.style.height = activePosition.height + "px";
		}

		//Add a onclick event to the tab to change the position of the slider
		elements.forEach((item) => {
			item.addEventListener("click", (event) => {
				//Remove the activeTab class first
				elements.forEach((item) => {
					item.classList.remove("activeTab");
				});

				//Add active class to the tab
				item.classList.add("activeTab");
				showTab(parseInt(item.id));

				//Set the position of slider to the tab
				let itemData = item.getBoundingClientRect();
				//Account for sidebar as well
				slider.style.left =
					(itemData.left - containPosition.left).toString() + "px";
				slider.style.width = itemData.width.toString() + "px";
			});
		});
	}

	function renderInventory(inventoryData, tab) {
		let renderData = [];
		if (Object.keys(inventoryData).length) {
			const { baseItems, ingredients } = inventoryData;
			if (tab === TABS.INGREDIENTS) {
				if (ingredients.length) {
					let ingredientTableData = [];
					const filteredIngredients = search(ingredients, searchParam, query);
					if (filteredIngredients.length) {
						for (const ingredient of filteredIngredients) {
							const {
								module,
								system,
								itemName,
								availableAmount,
								itemExpiresAt,
								error,
								disabled,
								disabledMessage,
								isDocked
							} = ingredient;

							const ingredientRowProps = {
								key: `${module}-${system}`,
								id:`${module}-${system}`
							};

							if (error) {
								ingredientRowProps["background"] = ErroredBackground;
							}

							ingredientTableData.push(
								<Trow disabled={disabled} className={"tooltip-element"} hoverEffect={false} {...ingredientRowProps} breakpoint="800px">
									<Tcol
										title="Module"
										breakpoint="800px"
										borderRadius="10px 0 0 10px">
										{module}
									</Tcol>
									<Tcol title="Slot" breakpoint="800px">
										{system}
									</Tcol>
									<Tcol title="Ingrdient" breakpoint="800px">
										{itemName}
									</Tcol>
									<Tcol title="Available Amount" breakpoint="800px">
										{availableAmount}
									</Tcol>
									<Tcol
										title="Expires At"
										breakpoint="800px"
										style={{ "white-space": "pre-line" }}>
										{formatDisplayDate(itemExpiresAt)}
									</Tcol>
									<Tcol
										title="Action"
										breakpoint="800px"
									>
										{isDocked ? <Button onClick={() => undockSystem({ moduleId: module, systemId: system })} >Undock</Button> : "-"}
									</Tcol>
									<Tcol
										borderRadius="0 10px 10px 0"
										title="Status"
										breakpoint="800px">
										{error || disabledMessage || "-"}
									</Tcol>
									
								</Trow>
							);
						}
					} else {
						//Empty State
					}

					renderData.push(
						<Table margin="2rem 0 0 0" widthBefore1000="90%" breakpoint="800px">
							<thead>
								<Trow head breakpoint="800px">
									<Thead>Module</Thead>
									<Thead>System</Thead>
									<Thead>Ingredient</Thead>
									<Thead>Available Amount</Thead>
									<Thead>Expires At</Thead>
									<Thead>Action</Thead>
									<Thead>Status</Thead>
								</Trow>
							</thead>
							<Tbody>{ingredientTableData}</Tbody>
						</Table>
					);
				} else {
					<Trow>No Records</Trow>;
				}
			} else if (tab === TABS.BASE_ITEMS) {
				if (Object.keys(baseItems).length) {
					let baseItemsTableData = [];
					const filteredBaseItems = search(baseItems, searchParam, query);
					if (filteredBaseItems.length) {
						for (const baseItem of filteredBaseItems) {
							const { itemId, itemName, itemExpiresAt, totalAvailableAmount } = baseItem;
							baseItemsTableData.push(<Trow key={itemId} breakpoint="800px" >
									<Tcol borderRadius="10px 0 0 10px" title="Ingredient" breakpoint="800px">
										{itemName}
									</Tcol>
									<Tcol title="Available Amount" breakpoint="800px">
										{totalAvailableAmount}
									</Tcol>
									<Tcol
										borderRadius="0 10px 10px 0"
										title="Expires At"
										breakpoint="800px"
										style={{ "white-space": "pre-line" }}>
										{formatDisplayDate(itemExpiresAt)}
									</Tcol>
							</Trow>)
						}
					}

					renderData.push(
						<Table margin="2rem 0 0 0" widthBefore1000="90%" breakpoint="800px">
							<thead>
								<Trow head breakpoint="800px">
									<Thead>Ingredient</Thead>
									<Thead>Available Amount</Thead>
									<Thead>Expiry</Thead>
								</Trow>
							</thead>
							<Tbody>{baseItemsTableData}</Tbody>
						</Table>
					);
				}
			}
		}
		return renderData;
	}

	async function FetchInventoryData() {
		setLoading(true);
		const response = await InventoryService.getInventory(kitchenId);
		const { data, error } = response;
		if (data) {
			const mappedInventory = mapInventory(data);
			props.getInventoryData(mappedInventory);
		}
		if (error) {
			errorNotification("Could not update Inventory data");
		}
		setLoading(false);
	}

	useEffect(() => {
		sliderMovement();
		closeModal();
		FetchInventoryData();
	}, []);

	useLayoutEffect(() => {
		if(Object.keys(inventoryData).length && !loading) {
			findAndScroll(pageQuery);
		}
	}, [inventoryData, loading]);

	return (
		<Page>
			<Div width="100%" jContent="flex-end" jContentBefore1000="center">
				<Container padding="1rem 0 0 0">
					<Button onClick={() => getInventoryFile()} margin="0.5rem">
						Get Inventory File
					</Button>
				</Container>
			</Div>

			<Div background="#f2f2f2" position="sticky" top="0" zIndex={zIndex.stickyHeader}>
				<TabContain id="contain">
					<Tab id={TABS.INGREDIENTS} className="tab activeTab">
						Ingredients
					</Tab>
					<Tab id={TABS.BASE_ITEMS} className="tab">
						Base Items
					</Tab>
					<Slider id="slider"></Slider>
				</TabContain>
			</Div>

			<SearchBar
				widthBefore700="80%"
				width="35rem"
				onChange={(e) => {
					setQuery(e.target.value);
				}}
			/>

			<Div margin="2rem 0 0 0">
				<Button onClick={() => FetchInventoryData()}>
					Get Latest Snapshot
				</Button>
			</Div>
			{!loading ? renderInventory(inventoryData, tab) : ""}
			{loading ? <Loader /> : ""}
			{/* <CSSTransition in={invFileModal} timeout={1000} classNames="module" unmountOnExit >
			<Overlay>
				<ConfirmModal>
						<Div color='#fff' background="rgba(45, 35, 66, 0.8)" padding="1rem" jContent="space-between">
							<Span fontSize="1.4rem" >Get Inventory File</Span>
							<img style={{'height':'1.5rem','filter':'invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)'}}  src={close} alt="close" onClick={() => {showInvFileModal(false)}}  />
							</Div>
					<Div padding="0 1rem" jContent="space-around" flexDirection="column" >
						<Div margin="1rem 0 0 0" flexDirection="column" >
							<Span margin="0 0 0.5rem 0">From:</Span>
							<InputBox padding="0.5rem" width="100%" onChange={(e) => setFrom(e.target.value)} type="date" />
						</Div>
						<Div margin="1rem 0 0 0" flexDirection="column" >
							<Span margin="0 0 0.5rem 0" >To:</Span>
							<InputBox padding="0.5rem" width="100%" onChange={(e) => setTo(e.target.value)} type="date" />
						</Div>
					</Div>
					<Div jContent="flex-end" padding="1rem" > 
						<Div margin="0.5rem"  onClick={() => {showInvFileModal(false)}} >
						<Button>Cancel</Button>
						</Div>
						<Div margin="0.5rem"  >
						<SuccessButton onClick={() =>{getInventoryFile()}} >Confirm</SuccessButton>
						</Div>
					</Div>
				</ConfirmModal>
			</Overlay>
			</CSSTransition>*/}
		</Page>
	);
};

const mapStateToProps = (state) => {
	const { inventory, landing } = state;
	return { ...inventory, ...landing };
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators(
		{
			...OperationActions,
		},
		dispatch
	),
});


export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
